import apiClient from "../../client/apiClient"

export type FeeStickerRow = {
  enrollmentId: string
  invoice: any | null
  variables: Record<string, string>
}

export const resolveFeeStickersApi = async (data: {
  enrollmentIds: string[]
  session?: string
}): Promise<{ success: boolean; data: FeeStickerRow[] }> => {
  const res = await apiClient({ method: "POST", url: "/fee-sticker/resolve", data })
  return res.data
}

export const feeStickerTemplateApi = async (): Promise<{ success: boolean; data: any }> => {
  const res = await apiClient({ method: "GET", url: "/fee-sticker/template" })
  return res.data
}
